module.exports = __webpack_public_path__ + "static/media/mobMsg.93903f68.svg";